const DOWNLOAD_STORAGE_KEY_PREFIX = "autovio-download:";

export function openDownloadWindow(): { navigate: (downloadUrl: string) => void; close: () => void } {
  const downloadKey = crypto.randomUUID();
  const storageKey = `${DOWNLOAD_STORAGE_KEY_PREFIX}${downloadKey}`;
  const downloadWindow = window.open(`/open-download.html#${downloadKey}`, "_blank");

  return {
    navigate: (downloadUrl) => {
      if (!downloadWindow) {
        window.location.assign(downloadUrl);
        return;
      }
      try {
        localStorage.setItem(storageKey, downloadUrl);
        window.setTimeout(() => localStorage.removeItem(storageKey), 60_000);
      } catch {
        downloadWindow.close();
        window.location.assign(downloadUrl);
      }
    },
    close: () => downloadWindow?.close(),
  };
}
